import { NavLink } from "react-router-dom";
import Image from "react-bootstrap/Image";

export default function PublicNav() {
    return (
        <nav className="navbar navbar-expand-md navbar-light border-bottom">
            <div className="container">
                <NavLink to="/" className="navbar-brand">
                    <Image src="/img/podsy-logo-w-200.png" fluid className={"w-50"} />
                </NavLink>

                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#topnav">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div id="topnav" className="collapse navbar-collapse">
                    <ul className="navbar-nav ms-auto mb-2 mb-md-0">
                        <li className="nav-item">
                            <NavLink to="/" className={({isActive}) => "nav-link" + (isActive ? " active" : "")} end>Info</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/corporate" className={({isActive}) => "nav-link" + (isActive ? " active" : "")} end>Corporate</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/login" className={({isActive}) => "nav-link" + (isActive ? " active" : "")}>Login</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/signup" className={({isActive}) => "nav-link" + (isActive ? " active" : "")}>Sign up</NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}
